import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LoadingService {
  private isLoadingSignal = signal<boolean | null>(null);
  public isLoading = this.isLoadingSignal.asReadonly();

  public showLoader(): void {
    if (!this.isLoadingSignal()) {
      this.isLoadingSignal.set(true);
    }
  }

  public hideLoader(): void {
    if (this.isLoadingSignal()) {
      this.isLoadingSignal.set(false);
    }
  }
}
